import { Component, Renderer, ElementRef  } from '@angular/core';
import { PopoverEditableIdNameDropdownComponent} from './popover-editable-id-name-dropdown.component';
import { IndustryService } from '../../_services';

@Component({
    selector: 'industry-template-dropdown',
    template: require('./popover-editable-dropdown.base.template.html')
})
export class IndustryTemplateDropdownComponent extends PopoverEditableIdNameDropdownComponent {
    constructor(
        private industryService: IndustryService,
        protected renderer: Renderer,
        protected element: ElementRef) {
        super(renderer, element);
    }

    protected getItems(): Promise<number[]> {
        return this.industryService.getTemplates().then(result => {
            this.dropdownItems = result;
            return this.dropdownItems.map(r => r.id);
        });

    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/industry-template-dropdown.component.ts